import { makeStyles } from "@material-ui/core/styles";
import { Colors } from "constants/constants";

export const useDashboardModalStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      padding: theme.spacing(0, 3, 3),
      width: 900,
      maxWidth: 900,
      borderRadius: "4px",
      boxShadow: "0px 1px 3px 0px #0000004D, 0px 4px 8px 3px #00000026",
    },
  },
  backDrop: {
    backdropFilter: "blur(3px)",
    backgroundColor: "#00000074",
  },
  closeBtn: {
    padding: 0,
    width: 40,
    minWidth: 40,
    height: 40,
  },
  openBtn: {
    color: "#0129FA",
    padding: theme.spacing(1),
  },
  customButtonElement: {
    cursor: "pointer",
    height: "100%",
    display: "flex",
    alightItems: "center",
  },
  disabledButton: {
    opacity: 0.5,
    cursor: "default",
    pointerEvents: "none",
    "&:hover": {
      opacity: 0.5,
    },
  },
  dialogContent: {
    padding: theme.spacing(0, 0, 3),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: 22,
  },
  description: {
    fontSize: 14,
    fontWeight: 400,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  graphHead: {},
  graphContent: {},
  "@media (max-width: 840px)": {
    graphHead: {
      width: 800,
    },
    graphContent: {
      maxWidth: 800,
      width: 800,
      minWidth: 800,
      overflowX: "scroll",
      overflowY: "hidden",
      whiteSpace: "nowrap",
    },
  },
}));

export const useModalStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      padding: theme.spacing(3, 0, 0),
      width: 440,
      maxWidth: 440,
      borderRadius: "4px",
      boxShadow: "0px 1px 3px 0px #0000004D, 0px 4px 8px 3px #00000026",
    },
  },
  backDrop: {
    backdropFilter: "blur(3px)",
    backgroundColor: "#00000074",
  },
  closeBtn: {
    padding: 0,
    width: 40,
    minWidth: 40,
    height: 40,
  },
  openBtn: {
    color: "#0129FA",
    padding: theme.spacing(1),
  },
  customButtonElement: {
    cursor: "pointer",
    height: "100%",
    // width: "100%",
    // display: "flex",
    // alightItems: "center",
  },
  disabledButton: {
    opacity: 0.5,
    cursor: "default",
    pointerEvents: "none",
    "&:hover": {
      opacity: 0.5,
    },
  },
  dialogTitle: {
    padding: theme.spacing(0, 3, 2),
    display: "flex",
    justifyContent: "space-between",
    "&.MuiDialogContent-root:first-child": {
      paddingTop: 0,
    },
  },
  dialogContent: {
    color: "#0E1011",
    padding: theme.spacing(0, 3, 3),
    display: "flex",
    flexDirection: "column",
  },
  dialogText: {
    color: "#0E1011",
    fontWeight: 400,
  },
  dialogBoldText: {
    color: "#0E1011",
    fontWeight: 600,
  },
  dialogActions: {
    borderTop: "1px solid #BEBFC0",
    "&.MuiDialogActions-root": {
      padding: theme.spacing(2, 3),
    },
  },
  title: {
    fontSize: 22,
    lineHeight: 1.5,
  },
  textLabel: {
    color: "#5F6164",
    fontSize: 14,
    fontWeight: 400,
    margin: theme.spacing(0, 0, 0.5),
  },
  noSelectionOption: {
    color: "#00000075",
  },
  errorMsg: {
    color: Colors.RED,
  },
  redTheme: {
    color: "#C42020",
  },
  addScroll: {
    overflow: "scroll",
    height: 110,
  },
  horizontalBox: {
    display: "flex",
    alignItems: "center",
  },
  "@media (max-width: 840px)": {
    customButtonElement: {
      flexGrow: 1,
    },
  },
}));
